/* Dansk katalog for locale-transaction-detail-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'transaction.annulBy': 'Annulleret af',
  "transaction.annulAudit": "Annulleringshistorik",
  "transaction.annulledAt": "Annulleret den",
  "transaction.annulReason": "Begrundelse",
  "transaction.annulActor": "Bruger-ID",
  "transaction.reversalDate": "Modposteringens bogføringsdato",
  "transaction.openOriginal": "Åbn oprindelig postering",
  "transaction.openReversal": "Åbn modpostering",
  "transaction.auditMissing": "Ikke registreret",
  "transaction.reversalMissing": "Modposteringen er ikke tilgængelig i den indlæste journal.",
  "transaction.auditDebit": "Debet",
  "transaction.auditCredit": "Kredit",

  'transaction.incompleteBasis': 'Journaldækningen er ufuldstændig. Dette bilag vises til dokumentation og diagnostik; totalerne må ikke tolkes som fuldstændige.',
  'route.transaction': 'Transaktion',
  'transaction.back': 'Tilbage til alle transaktioner',
  'transaction.title': 'Transaktion',
  'transaction.posting': 'Postering',
  'transaction.summary': 'Opsummering – beløb ind og ud af konti',
  'transaction.account': 'Konto',
  'transaction.incoming': 'Ind på konto',
  'transaction.outgoing': 'Ud af konto',
  'transaction.total': 'Sum',
  'transaction.description': 'Beskrivelse',
  'transaction.links': 'Tilknyttede poster',
  'transaction.sourceLead': 'Dette er bogføring af',
  'transaction.sourceHelp': 'Åbn kilden, hvis du skal foretage ændringer i transaktionen eller en tilknyttet betaling.',
  'transaction.relatedPayments': 'Relaterede betalinger',
  'transaction.correctionReplacement': 'Erstatningsbilag',
  'transaction.correctionOriginal': 'Oprindeligt bilag',
  'transaction.correctionReason': 'Årsag til korrektion',
  'transaction.created': 'Oprettet',
  'transaction.by': 'af',
  'transaction.vatCodes': 'Momskoder',
  'transaction.accountNumber': 'Kontonr.',
  'transaction.name': 'Navn',
  'transaction.amount': 'Beløb',
  'transaction.documentation': 'Dokumentation',
  'transaction.generatedDocument': 'Fakturadokumentet genereres, når du åbner eller downloader det.',
  'transaction.noDocumentation': 'Der er ikke vedhæftet dokumentation til denne transaktion.',
  'transaction.open': 'Åben postering',
  'transaction.locked': 'Låst postering',
  'transaction.annulled': 'Annulleret',
  'transaction.fallbackType': 'Postering',
  'transaction.notFound': 'Kunne ikke finde transaktionen',
  'transaction.notFoundHelp': 'Transaktionen kan være annulleret, høre til et andet regnskabsår eller ikke længere være tilgængelig.',
  'transaction.invoice': 'Faktura',
  'transaction.purchase': 'Køb',
  'transaction.otherSale': 'Andet salg',
  'transaction.customs': 'Tolddeklaration',
  'transaction.openDocument': 'Se bilag',
  'transaction.download': 'Download',
  'transaction.upload': 'Upload vedhæftning',
  'transaction.uploaded': 'Vedhæftning uploadet.',
  'transaction.uploadFailed': 'Kunne ikke uploade vedhæftningen.',
  'transaction.documentFailed': 'Kunne ikke hente bilaget fra backend.',
  'transaction.previewFailed': 'Kunne ikke vise bilaget.',
  'transaction.lost': 'Bilag bortkommet',
  'transaction.lostPrompt': 'Forklaring til loggen (valgfrit):',
  'transaction.lostSaved': 'Bilaget er markeret som bortkommet.',
  'transaction.lostFailed': 'Kunne ikke markere bilaget som bortkommet.',
  'transaction.annul': 'Annuller transaktion',
  'transaction.annulQuestion': 'Annuller transaktion?',
  'transaction.creditQuestion': 'Kreditér faktura?',
  'transaction.credit': 'Kreditér',
  'transaction.annulling': 'Annullerer...',
  'transaction.annulHelp': 'Transaktionen annulleres og bevares som historik, men medtages ikke i rapportgrundlaget.',
  'transaction.creditHelp': 'Fakturaen krediteres med en kreditnota, der oprettes som kladde til kontrol før afsendelse.',
  'transaction.creditDraft': 'Kreditnotaen er oprettet som kladde. Kontrollér og send den fra fakturalisten.',
  'transaction.annulledSaved': 'Transaktionen er annulleret.',
  'transaction.annulFailed': 'Kunne ikke annullere transaktionen.',
  'transaction.privateReimbursed': 'Det private udlæg er refunderet.',
  'transaction.privateReimburseFailed': 'Kunne ikke refundere det private udlæg.',
  'transaction.reimbursePrivate': 'Refundér privat udlæg',
  'transaction.reimbursePrivateHelp': 'Bogfører refusionen fra den valgte firmabankkonto mod konto 2060 uden at bogføre omkostning eller moms igen.',
  'transaction.paymentDate': 'Betalingsdato',
  'transaction.bankAccount': 'Bankkonto',
  'transaction.goTo': 'Gå til',
  'transaction.bank': 'Bank',
  'transaction.vat': 'Moms',
  'transaction.yearEnd': 'Årsafslutning',
});
